import React from 'react';
import styled from 'styled-components';
import {AccentColorOptions} from 'epic-ue-theme';
import {AnimateOnViewWrap, UeLink, WithCaption, WithCaptionProps} from '../../wraps';
import Grid from '@material-ui/core/Grid';
import {ImageProps, Image} from '../images';
import {CmsButtonProps} from '../buttons';
import {TruncateTextParagraph} from '../text/TruncateTextParagraph';
import {Eyebrow} from '../eyebrow';

const Styled = styled.div<{imageAlignTop?: boolean}>`
    && .MuiGrid-item.image-and-textcard-sm-img {
        align-self: center;
        padding: 3px;
    }

    && .MuiGrid-item.image-and-textcard-sm-text {
        padding-left: 16px;
    }
`;

export interface ImageAndTextCardSmallProps {
    heading?: string;
    title?: string;
    eyebrow?: string;
    image?: ImageProps;
    caption?: WithCaptionProps;
    description?: string;
    accentColor?: AccentColorOptions;
    button?: CmsButtonProps;
    imageAlignTop?: boolean;
}

export const ImageAndTextCardSmall = (props: ImageAndTextCardSmallProps): JSX.Element => {
    const {
        eyebrow,
        heading,
        title,
        image = {},
        caption = {},
        description,
        button = {},
        imageAlignTop
    } = props;

    const el: JSX.Element = (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={3}
            key={`itc-grid-${heading || title}`}>
            <Grid className="image-and-textcard-sm-img" item xs={4}>
                <UeLink href={button.href} title={heading || title}>
                    <WithCaption {...caption}>
                        <Image {...image} fit="cover" />
                    </WithCaption>
                </UeLink>
            </Grid>
            <Grid item xs={8} className="image-and-textcard-sm-text">
                {eyebrow && (
                    <div className="image-and-textcard-sm-eyebrow">
                        <Eyebrow text={eyebrow} />
                    </div>
                )}
                <TruncateTextParagraph
                    typographyVariant="h3"
                    maxLines={2}
                    hideShowMoreButton={true}
                    text={description}
                />
            </Grid>
        </Grid>
    );

    return (
        <AnimateOnViewWrap translateY={60}>
            <Styled
                className="ue-image-and-text-card-small"
                key={`itc-${heading || title}`}
                imageAlignTop={imageAlignTop}>
                {el}
            </Styled>
        </AnimateOnViewWrap>
    );
};
